// extracted by mini-css-extract-plugin
export default {"tabs":"PatientForm_tabs__5Vwud"};